import { AccountInfoDTO } from "~/account.info.dto";
import { SaveRequestDTO } from "~/save.request.dto";
import { ApiCatch } from "@/utils/decorators";
import { Api } from "../api.service";
import { SaveFileDTO } from "~/save.file.dto";

export class RequestsService {
  @ApiCatch
  static async getRequestList() {
    const response = await Api.get("/requests/list");
    return response.data;
  }

  @ApiCatch
  static async getData(RID: number) {
    const response = await Api.get(`/requests/data/${RID}`);
    return response.data;
  }

  @ApiCatch
  static async getAttachments(RID: number) {
    const response = await Api.get(`/requests/attachments/${RID}`);
    return response.data;
  }

  @ApiCatch
  static async saveData(req: SaveRequestDTO) {
    const response = await Api.post("/requests/save", req);
    return response.data;
  }

  @ApiCatch
  static async getAccountDebtInfo(req: AccountInfoDTO) {
    const response = await Api.get("/requests/getAccountDebtInfo/", {
      params: { ...req },
    });
    return response.data;
  }

  @ApiCatch
  static async getFile(attach_id: number) {
    const response = await Api.get(`/requests/getFile/${attach_id}`);
    return response.data;
  }

  @ApiCatch
  static async deleteFile(attach_id: number) {
    const response = await Api.get(`/requests/deleteFile/${attach_id}`);
    return response.data;
  }

  @ApiCatch
  static async uploadFile(req: SaveFileDTO) {
    const response = await Api.post(
      "/requests/uploadfile?RID=" +
        req.RID.toString() +
        "&attatchment_type_rid=" +
        req.attatchment_type_rid.toString(),
      req.data,
    );
    return response.data;
  }

  @ApiCatch
  static async checkNumberIIN(IIN: string) {
    const response = await Api.get(`/requests/checkNumberIIN/${IIN}`);
    return response.data;
  }

  @ApiCatch
  static async deleteRequest(RID: number) {
    const response = await Api.get(`/requests/deleteRequest/${RID}`);
    return response.data;
  }

  @ApiCatch
  static async signAndSend(RID: number, data: FormData) {
    const response = await Api.post(`/requests/signAndSend/${RID}`, data);
    return response.data;
  }

  @ApiCatch
  static async downloadPDF(reqNumber: number) {
    const response = await Api.get(`/requests/getSignRequest/${reqNumber}`);
    return response.data;
  }
}
